// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import LiveClass from "./pages/LiveClass";
import AnalysisDashboard from "./pages/AnalysisDashboard";
import "./App.css";

// Where each role lands after login. Admin and coach share the dashboard.
function homeFor(userRole) {
  if (userRole === "admin" || userRole === "coach") return "/admin";
  if (userRole === "student") return "/student";
  return "/login";
}

// `roles` is an array of allowed roles. Omit it to allow any logged-in user.
function ProtectedRoute({ children, roles }) {
  const { user, userRole, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/><p>Loading...</p></div>;
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(userRole)) return <Navigate to={homeFor(userRole)} />;
  return children;
}

function AppRoutes() {
  const { user, userRole, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/><p>Loading...</p></div>;
  return (
    <Routes>
      <Route path="/login" element={!user ? <LoginPage /> : <Navigate to={homeFor(userRole)} />} />
      <Route path="/admin" element={<ProtectedRoute roles={["admin", "coach"]}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/student" element={<ProtectedRoute roles={["student"]}><StudentDashboard /></ProtectedRoute>} />
      <Route path="/class/:classId" element={<ProtectedRoute><LiveClass /></ProtectedRoute>} />
      <Route path="/analysis" element={<ProtectedRoute><AnalysisDashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
